import { useState } from "react";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const DigestPreviewButton = () => {
  const [open, setOpen] = useState(false);
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    try {
      const r = await api.get("/clients/digest-preview");
      setPreview(r.data);
      setOpen(true);
    } catch (e) { toast.error(errorMessage(e)); } finally { setBusy(false); }
  };

  return (
    <>
      <Button type="button" variant="outline" onClick={load} disabled={busy} className="rounded-full border-indigo-200 text-indigo-700 hover:bg-indigo-50" data-testid="digest-preview-button">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mail className="w-4 h-4" />} {busy ? "Building…" : "Preview this week's digest"}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl p-0 overflow-hidden rounded-3xl" data-testid="digest-preview-dialog">
          <DialogHeader className="px-6 pt-6">
            <DialogTitle className="font-display">Monday digest preview</DialogTitle>
            <DialogDescription data-testid="digest-preview-subject">
              {preview?.subject ? <>Subject: <span className="font-medium text-slate-800">{preview.subject}</span></> : "You have no clients yet, so no digest will be sent."}
            </DialogDescription>
          </DialogHeader>
          {preview?.html && (
            <iframe title="Digest preview" srcDoc={preview.html} sandbox="" className="w-full h-[70vh] bg-slate-100 border-t border-slate-200" data-testid="digest-preview-frame" />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
